"use strict";

require("./index.less");

require("../../breadcrumb/style");

require("../../avatar/style");